import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type AdminPartnerDealStatus = "won" | "lost" | "open";

export type AdminPartnerDealRow = {
  hubspotDealId: string;
  title: string;
  amount: number | null;
  currency: string;
  stageId: string | null;
  stageLabel: string | null;
  status: AdminPartnerDealStatus;
  closeDate: string | null;
  createdAt: string;
  hubspotUrl: string;
  relationship: string;
};

export type AdminPartnerDealsResponse = {
  rows: AdminPartnerDealRow[];
  counts: { all: number; open: number; won: number; lost: number };
};

export function useAdminPartnerDeals(partnerId: string | undefined) {
  return useQuery<AdminPartnerDealsResponse, ApiClientError>({
    queryKey: queryKeys.admin.partners.deals(partnerId ?? ""),
    queryFn: () =>
      apiFetch<AdminPartnerDealsResponse>(`/admin/partners/${partnerId}/deals`),
    enabled: !!partnerId,
  });
}
